import React from "react";
import ls from "localstorage-slim";
import moment from "moment";
import "moment/locale/fr";

moment.locale("fr");

const LicenceBanner = () => {
  const licence = ls.get("licence");
  if (!licence || !licence.valid) return null;

  const { days_remaining, expires_at, status } = licence;
  if (status !== "active") return null;

  let alertClass = "alert alert-info alert-bold";
  let message = "";

  if (days_remaining <= 0) {
    alertClass = "alert alert-danger alert-bold";
    message = `Votre licence expire le ${moment(expires_at).format("LLL")}`;
  } else if (days_remaining <= 3) {
    alertClass = "alert alert-danger alert-bold";
    message = `Votre licence expire dans ${days_remaining} jour${days_remaining > 1 ? "s" : ""} — le ${moment(expires_at).format("LLL")}`;
  } else if (days_remaining <= 7) {
    alertClass = "alert alert-warning alert-bold";
    message = `Votre licence expire dans ${days_remaining} jours — le ${moment(expires_at).format("LLL")}`;
  } else {
    message = `Votre licence est valide — ${days_remaining} jours restants — expire le ${moment(expires_at).format("LLL")}`;
  }

  return (
    <div
      style={{
        margin: 0,
        borderRadius: 0,
        textAlign: "center",
        padding: "6px 15px",
        fontSize: "13px",
        border: "none",
      }}
      className={alertClass}
      role="alert"
    >
      {message}
    </div>
  );
};

export default LicenceBanner;
